'use client';

import React from 'react';
import './BackgroundMask.scss';

interface BackgroundMaskPropTypes {
    mask: string;
}

export const BackgroundMask: React.FC<BackgroundMaskPropTypes> = (props) => {
    const { mask } = props;

    return (
        <div
            style={{
                '--shop-ui-background-mask': mask,
            }}
            className="background-mask"
        />
    );
};
